<template>
  <div>
    <v-app-bar id="app-toolbar" app flat>
      <div class="page-title">{{ title }}</div>
      <div class="page-search">
        <Search />
      </div>
      <v-spacer />
      <Logout @open-modal="openModalHandler" />
    </v-app-bar>
    <LogoutModal :show="show" :name="userName" @close-logout-modal="closeModalHandler" @set-logout="setLogout" />
  </div>
</template>

<script>
import Logout from './Logout'
import Search from './Search'
import LogoutModal from './LogoutModal'
export default {
  name: 'Navbar',
  components: { LogoutModal, Logout, Search },
  data: () => ({
    search: '',
    show: false,
    userName: ''
  }),
  computed: {
    title() {
      return this.$store.state.navTitle
    }
  },
  methods: {
    openModalHandler(name) {
      this.show = true
      this.userName = name
    },
    closeModalHandler() {
      this.show = false
    },
    setLogout() {
      this.$store.commit('LOGOUT')
      this.$store.commit('CLEAR_STATE')
      this.$store.commit('SAVE_NAV_TITLE', 'Абоненты')
    }
  }
}
</script>

<style lang="scss" scoped>
#app-toolbar {
  padding-top: 28px;
  padding-left: 20px;
  height: 90px !important;
  .page {
    &-title {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      line-height: 32px;
      color: #000000;
      margin-right: 32px;
    }
    &-search {
      max-width: 540px;
    }
  }
  #search-input {
    padding-top: 28px;
  }
}
</style>
